import { GuideComponent } from './modules/components/guide/guide.component';
import { ApiService } from './services/api.service';
import { UserInfosComponent } from './modules/components/user-infos/user-infos.component';
import { CguComponent } from './modules/components/cgu/cgu.component';
import { ChangePasswordComponent } from './modules/components/change-password/change-password.component';
import { LoginComponent } from './modules/components/login/login.component';
import { ContactUsComponent } from './modules/components/contact-us/contact-us.component';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { Component } from '@angular/core';

import { Platform, ModalController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { StoreService } from './services/store.service';
import { NavService } from './services/nav.service';
import { UserService } from './services/user.service';
import { UiService } from './models/ui-service';
import { Ui } from './services/ui.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  // public appPages = [
  //   {
  //     title: 'Tableau de bord',
  //     url: '/dash',
  //     icon: 'home'
  //   },
  //   {
  //     title: 'Parametrage',
  //     url: '/settings',
  //     icon: 'settings'
  //   },
  //   {
  //     title: 'Utilisateurs',
  //     url: '/users',
  //     icon: 'people'
  //   },
  //   {
  //     title: 'Offre et Promo',
  //     url: '/offers-promo',
  //     icon: 'gift'
  //   },
  //   {
  //     title: 'Notifications',
  //     url: '/push-notifications',
  //     icon: 'send'
  //   }, {
  //     title: 'Publicité',
  //     url: '/ads',
  //     icon: 'jet'
  //   }
  // ];
  // appPages: UiService[];
  loaded = false;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private store: StoreService,
    public navService: NavService,
    public ui: Ui,
    private modalController: ModalController,
    public userService: UserService,
    public apiService: ApiService) {
    // this.appPages = ui.services.filter(e => ui.hasPermission(e));
    this.initializeApp();
  }
  initializeApp() {
    this.store.load().then(d => {
      console.log('Data', d);
    }).catch(err => {
      console.log('Error', err);
    });
    this.loaded = true;
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
  async logout() {
    await this.store.merge({
      accessToken: null,
      userLogin: null
    });
    window.location.href = '';
  }


  async login() {
    const modal = await this.modalController.create({
      component: LoginComponent
    });
    await modal.present();
  }
  async contactUs() {
    const modal = await this.modalController.create({
      component: ContactUsComponent,
      componentProps: { data: this.userService.currentUser },
    });
    await modal.present();
  }
  async changePassword() {
    console.log('test changePawword');
    const modal = await this.modalController.create({
      component: ChangePasswordComponent
    });
    await modal.present();
  }
  async cgu() {
    const modal = await this.modalController.create({
      component: CguComponent,
    });
    await modal.present();
  }

  async goToInfoUser() {
    const modal = await this.modalController.create({
      component: UserInfosComponent,
      componentProps: { user: this.userService.currentUser },
    });
    await modal.present();
  }

  async guide() {
    const modal = await this.modalController.create({
      component: GuideComponent,
      cssClass: 'my-modal'
    });
    await modal.present();
  }
}
